import axios from "axios";

export default {
  namespaced: true,
  state: {
    users: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    usersMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = state.isReceiving==true ? true : false;
    },
    RECEIVED_USERS(state, payload) {
      state.users = payload;
      state.isReceiving = false;
    },
    RECEIVING_USERS(state) {
      state.isReceiving = true;
    },
    RECEIVED_USER(state, payload) {
      console.log("RECEIVED USER", payload);
      state = Object.assign(state, {
        users: [...state.users, payload],
        isReceiving: false,
      })
    },
    RECEIVING_USER(state) {
      state.isReceiving = true;
    },
    UPDATED_USER(state, payload) {
      console.log(state.users);
      console.log(payload);
      let index = state.users.findIndex(user => user._id === payload._id);
      state = Object.assign(state, {
        users: state.users.map((user, i) => {
          if (i === index) {
            return Object.assign({}, user, payload);
          }
          return user;
        }),
        isUpdating: false,
        usersMessage: 'Users has been updating!',
      })
    },
    UPDATING_USER(state) {
      state.isUpdating = true;
    },
    DELETED_USER(state, payload) {
      let indexToDelete = state.users.findIndex(user => user._id === payload._id);
      let users = [...state.users];
      users.splice(indexToDelete, 1);
      state = Object.assign(state, {
        users: [...users],
        isDeleting: false,
        idToDelete: null,
        usersMessage: 'User has been Deleted!',
      });
    },
    DELETING_USER(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    createUserRequest({dispatch}, payload) {
      dispatch("receivingUsers");
      var url;
      var data;
      var header;
      var token = localStorage.getItem('token');

      if(payload.userimage !== undefined) {
        url = 'https://api.tradexc.com:3000/insert/user/withimage';
        data = new FormData();
        data.append('image', payload.userimage, payload.imagename); 
        delete payload['userimage'];
        for (let x in payload) {
          data.append(x, payload[x]);
        }
        header = {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + token
        };
      } else {
        url = 'https://api.tradexc.com:3000/insert/user';
        data = payload;
        header = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        };
      }
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("receiveUser", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    async getUsersRequest({dispatch}) {
      dispatch("receivingUsers");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/users';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: headers})
      .then(res => {
        dispatch("receiveUsers", res.data);
      })
    },
    async getUsersAllRequest({dispatch}) {
      try{
        dispatch("receivingUsers");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/get/users/all';
        let response = await axios({method: "get", url: url, headers: headers});
        console.log('all-users',response.data)
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getUsersMarketProjectRequest({dispatch}) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/get/users/marketproject';
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getUsersCreativeProjectRequest({dispatch}) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/get/users/creativeproject';
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateUserRequest({dispatch}, payload) {
      dispatch("updatingUser");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/user/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: headers, data: payload})
      .then(function (res) {
        dispatch("updateUser", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateUserPasswordRequest({dispatch}, payload) {
      dispatch("updatingUser");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/user/password/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: headers, data: payload})
      .then(function (res) {
        dispatch("updateUser", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    updateUserOptionsRequest({dispatch}, payload) {
      dispatch("updatingUser");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/user/options/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: headers, data: payload})
      .then(function (res) {
        dispatch("updateUser", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    updateUserImageRequest({dispatch}, payload) {
      dispatch("updatingUser");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.tradexc.com:3000/update/user/image/' + id;
      let data = new FormData();
      data.append('image', payload.userimage, payload.imagename); 
      delete payload['userimage'];
      for (let x in payload) data.append(x, payload[x]);
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      axios({method: "put", url: url, headers: headers, data: data})
      .then(function (res) {
        dispatch("updateUser", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    deleteUserRequest({dispatch}, payload) {
      dispatch("deletingUser", payload);
      console.log(payload);
      axios.delete('https://api.tradexc.com:3000/delete/user/' + payload._id).then(() => {
        dispatch("deleteUser", {_id: payload._id});
      })
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveUsers({commit}, payload) {
      commit("RECEIVED_USERS", payload)
    },
    receivingUsers({commit}) {
      commit("RECEIVING_USERS")
    },
    receiveUser({commit}, payload) {
      console.log("HERE");
      console.log(payload);
      commit("RECEIVED_USER", payload)
    },
    receivingUser({commit}) {
      commit("RECEIVING_USER")
    },
    updateUser({commit}, payload) {
      commit("UPDATED_USER", payload)
    },
    updatingUser({commit}) {
      commit("UPDATING_USER")
    },
    deleteUser({commit}, payload) {
      commit("DELETED_USER", payload)
    },
    deletingUser({commit}, payload) {
      commit("DELETING_USER", payload)
    }
  },
};
